import { render } from "./LoginButtonComponent.vue?vue&type=template&id=7dd8922e&ts=true"
import script from "./LoginButtonComponent.vue?vue&type=script&lang=ts"
export * from "./LoginButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__